var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.userCanSeeAlerts)?_c('div',[_vm._t("default",null,{"busy":_vm.busyLoading,"error":_vm.errLoading,"hasAlerts":_vm.hasAlerts,"alerts":_vm.alerts,"alertsRoute":_vm.alertsRoute})],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d27e1d7","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/broilerAdmin/components/AdminAlertsLoader.vue
// module id = null
// module chunks = 